import { PoiActionService } from 'src/app/core/poi/poi.action';
import { IPoi } from 'src/app/core/poi/poi.model';
import { IItin } from 'src/app/core/itinerari/itinerari.model';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, tap, mergeMap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { of } from 'rxjs';
import { Itin } from '../core/itinerari/itinerari.model';
import { ItinActionService } from '../core/itinerari/itinerari.action';

@Injectable()
export class EditableItinResolver implements Resolve<Itin> {

  constructor(private service: ApiService,
              private itinAction: ItinActionService,
              private poiAction: PoiActionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const actualRoute = state.url;
    const idFromUrl = parseInt(actualRoute.split('/').pop(), 10);
    return this.service.editableItin(idFromUrl).pipe(
      first(),
      mergeMap((data: any) => {
        const itinerary: IItin = Itin.from(data);
        this.itinAction.setItinCurrent(itinerary);
        return this.service.getSelectedPoiForItin(itinerary.geopos[0].id).pipe(first());
      }),
      tap((poiList: IPoi[]) => {
        this.poiAction.poiList(poiList);
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare il singolo Itinerario');
        return of(err);
      })
    );
  }
}
